import { render, staticRenderFns } from "./rap-tag-input.vue?vue&type=template&id=319d9781&scoped=true&"
import script from "./rap-tag-input.vue?vue&type=script&lang=js&"
export * from "./rap-tag-input.vue?vue&type=script&lang=js&"
import style0 from "./rap-tag-input.vue?vue&type=style&index=0&id=319d9781&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319d9781",
  null
  
)

export default component.exports